import React, { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    ShowButton, ReferenceField, TopToolbar, CreateButton,
} from 'react-admin';

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* No gate here on purpose: react-admin asks `authProvider.canAccess` for this button
                itself, and the map there names the verb. A check beside it would be the same
                rule written twice. */}
                <CreateButton />
            {/*<FilterButton />*/}
        </TopToolbar>
    );
}

export const CouponsList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions/> }
        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="name"  />
                <TextField source="code"/>
                <ShowButton label="View" />
            </Datagrid>
        </List>
    );
}
